import React, { memo, useContext, useEffect } from "react";
import { UiIconButton } from "./common/form/UiButton";
import { PlusRoundedIcon } from "../../styles/images/svg/DashboardGridIcons";
import { Context } from "../../_context/Store";

export const ContentRightWr = (props) => {

    const [state, dispatch] = useContext(Context);

    return (
        <div className="sbt-dashboard-right__wr" style={state.ui_sidebar_open ? { marginLeft: '300px' } : { marginLeft: '50px' }}>
            {props.children}
        </div>
    )
}
export const MainLeftTitle = memo((props) => {
    const { title, button, children } = props;
    return (
        <div className="sbt-dashboard-right__title">
            {title}
            <div className="sbt-dashboard-right__btn-wr">
                {children}
            </div>

        </div>
    )
})

export const CreateButton = memo((props) => {
    const { name, onClick } = props;
    return (
        <UiIconButton
            icon={<PlusRoundedIcon />}
            variant='contained'
            name={name}
            onClick={onClick} />
    )
})